import uniq from 'lodash/uniq';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularSpinner from '@mui/material/CircularProgress';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';
import {
  getServiceCategories,
  getDefaultSessionTypeDescription
} from '../../helpers/selectOptions';
import getServiceIcon from '../availabilities/getServiceIcon';
import {
  useGetProviderAvailabilitiesQuery
} from '../../redux/services/providerAvailabilityApi';

const parseQuery = ({location = null, providerId = null}) => {
  let query = {
    include_nonpublic: true,
  };
  console.log('parseQuery', {location, providerId});
  if (location) {
    query.lat = location.lat;
    query.lon = location.lon;
    query.distance = 30;
  }
  if (providerId) query.provider_id = providerId;
  return query;
};

const PatientSchedulingServiceForm = ({
  onSubmit,
  stepNum = 2,
  allowedServiceCategories = null,
  sessionTypes = null,
  location = null,
  providerId = null,
  allowManualScheduling = false,
  onScheduleManually = null,
  subtitle = 'Select the type of care you need',
}) => {
  const availabilitiesQuery = useGetProviderAvailabilitiesQuery(
    parseQuery({location, providerId}), 
    {}
  );
  const serviceCategoriesNearby = uniq(
    (availabilitiesQuery?.data?.data || []).flatMap(az => 
      az.configs.map(c => c.session_type.service_category)
    )
  );
  // console.log('availabilitiesQuery', availabilitiesQuery, serviceCategoriesNearby);
  const options = getServiceCategories()
    .filter(cat => serviceCategoriesNearby.includes(cat.value))
    .filter(cat => 
      !allowedServiceCategories 
      || allowedServiceCategories.includes(cat.value)
    )
    .map(cat => ({
      label: cat.label,
      value: cat.value,
      description: (
        (sessionTypes && sessionTypes.find(st => st.service_category === cat.value)?.description)
        || cat.description
      ),
      color: cat.colorName,
      xs: 12,
      md: 12,
      lg: 12,
      xl: 12,
    }));
  return (
    <Stack spacing={1} alignItems='left'>
      <Typography variant='h2'>What service are you looking for?</Typography>
      <Typography>{subtitle}</Typography>
      <Box style={{width: '100%'}}>
        <ChoiceField
          choiceStyle='card'
          layout='row'
          useColoredBackground={false}
          options={options.map(o => ({
            ...o, 
            Icon: getServiceIcon({service: o.value}),
            description: o?.description || getDefaultSessionTypeDescription(o.value),
          }))}
          onChange={(e, val) => onSubmit(e, val)}
        />
      </Box>
      {
        availabilitiesQuery?.isSuccess && !availabilitiesQuery?.data?.data?.length &&
        <Stack direction='row' gap={0.5} alignItems='center' justifyContent='center'>
          {/* <SearchIcon style={{fontSize: '1.5rem', marginRight: '0.5em'}} color='secondary'/> */}
          <Typography variant='h3' align='center' color='text.gray'>
            We're sorry we don't currently serve this region. 
            Try another search or contact us at{' '}
            <a href='mailto:info@movement-x.com'>info@movement-x.com</a>
            {' '}for further assistance.  
          </Typography>
        </Stack>
      }
      {
        availabilitiesQuery.isFetching &&
          <Stack direction='row' mt={2} justifyContent='center'>
            <CircularSpinner />
          </Stack>
      }
      {allowManualScheduling && !!onScheduleManually &&
        <Button
          variant='text'
          size='small'
          onClick={onScheduleManually}
        >
          Skip Scheduling for Now
        </Button>
      }
    </Stack>
  );
};

export default PatientSchedulingServiceForm;